// Feel free to substitute the text below with your specific terms and conditions that you want users to agree to before getting access to their AWS accounts
// You can use Markdown syntax to format the text.
// This text will be display above the "Accept & Open AWS Console" links

const termsAndConditionsText = `
### Terms & Conditions

1. By using "AllianzTech playground" for this event, you agree to the [AWS Event Terms and Conditions](https://aws.amazon.com/events/terms/) and 
the [AWS Acceptable Use Policy](https://aws.amazon.com/aup/). You acknowledge and agree that are using an AWS account that you can only access for the duration of the relevant 
event. If you find residual resources or materials in the AWS account, you will make us aware and cease use of the account. We reserve the right to terminate 
the account and delete the contents at any time.

1. You will not: (a) process or run any operation on any data other than test data sets or lab-approved materials by us, and (b) copy, import, export or otherwise 
create derivate works of materials provided by AWS, including but not limited to, data sets.

1. We are under no obligation to enable the transmission of your materials through "AllianzTech playground" and may, in its discretion, edit, block, refuse to post, 
or remove your materials at any time.

1. Your use of "AllianzTech playground" will comply with these terms and all applicable laws, and your access to "AllianzTech playground" will immediately 
and automatically terminate if you do not comply with any of these terms or conditions.
`;

export default termsAndConditionsText;
